import ApiClient from "../api/ApiClient"

/**
 * Validates a user's json web (access) token by first
 * checking if it exists in local storage, and validating
 * it with our api if it does.
 */
export default async function validateToken() {
  if (__DEMO_MODE__) {
    const { seedDemoSession } = require("../mock/demoAdminState")
    seedDemoSession()
    return true
  }
  try {
    /* Check if token is available */
    const token = localStorage.getItem("access-token")
    if (token === null) return false
    /* Validate token if it is available */
    const response = await ApiClient.post("/authenticate")
    return response.status === 200
  } catch (error) {
    console.error(error)
    return false
  }
}
